import { Factory } from "@/data/dao/Factory";
import { CatalogDao } from "@/data/dao/service/CatalogDao";
import type { IOptionGroup } from "@/data/model/OptionGroup";
import { Format } from "@/data/util/Format";



import { i18n } from "@/portal/Trans";
import { BaseTabbedController } from "@/portal/controller/BaseTabbedController";
import { OptionGroupForm } from "@/portal/forms/OptionGroupForm";
import { TastierGlobal } from "@/portal/globalAccess";
import { UiNotification } from "@/portal/ui/Notification";


export class OptionGroupController extends BaseTabbedController<IOptionGroup> {
    private optionGroupForm: OptionGroupForm;

    constructor(element: JQuery) {
        super(element, Factory.getInstance<CatalogDao>(CatalogDao).optionGroupDataSource);

        this.optionGroupForm = new OptionGroupForm(this.formContentByTabName("optiongroupedit"));
        this.registerModelForm(this.optionGroupForm);
    }

    protected onModelLoaded(m?: IOptionGroup) {
        if (this.copyEntityId != null) {
            UiNotification.showSuccess(i18n("optionGroup.optionGroupCopiedAndEditingNow"));
        }
        
        
        if (m === undefined) {
            const vw = $("#kt_header > #kt_header_menu_wrapper");
            if (vw.find("> .selectedlocation").length === 0)
                vw.append(
                    '<div class="selectedlocation">' +
                        Format.htmlEscape(TastierGlobal.getLocationSwitch()!.getCurrentLocationName()) +
                        "</div>"
                );
        }

        this.optionGroupForm.setData(m, this.copyEntityId);
    }
}
